import {
  AlertTriangle,
  ArrowRight,
  BellRing,
  Calendar,
  Car,
  Check,
  CheckCircle2,
  ChevronLeft,
  ChevronRight,
  ClipboardList,
  Clock,
  Coins,
  Eye,
  FileSearch,
  FileText,
  Gauge,
  History,
  Layers,
  Lock,
  Menu,
  RefreshCw,
  Shield,
  ShieldAlert,
  ShieldCheck,
  Sparkles,
  TrendingUp,
  Wrench,
  X,
  Search,
} from "lucide-react";

const ICONS = {
  "alert-triangle": AlertTriangle,
  "arrow-right": ArrowRight,
  "bell-ring": BellRing,
  calendar: Calendar,
  car: Car,
  check: Check,
  "check-circle-2": CheckCircle2,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  "clipboard-list": ClipboardList,
  clock: Clock,
  coins: Coins,
  eye: Eye,
  "file-search": FileSearch,
  "file-text": FileText,
  gauge: Gauge,
  history: History,
  layers: Layers,
  lock: Lock,
  menu: Menu,
  "refresh-cw": RefreshCw,
  shield: Shield,
  "shield-alert": ShieldAlert,
  "shield-check": ShieldCheck,
  sparkles: Sparkles,
  "trending-up": TrendingUp,
  wrench: Wrench,
  x: X,
  search: Search,
};

/** Lucide pack wrapper matching the Cloud White Icon recipe. */
export function Icon({ name, size = 18, className = "" }) {
  const Comp = ICONS[name] || ArrowRight;
  return <Comp width={size} height={size} strokeWidth={1.75} className={className} aria-hidden />;
}
